import BankAccountEndpoint from "@/core/services/api/endpoints/manager/BankAccountEndpoint";
import NotificationEndpoint from "@/core/services/api/endpoints/manager/NotificationEndpoint";
import ActivityLogEndpoint from "@/core/services/api/endpoints/manager/ActivityLogEndpoint";
import CompanyEndpoint from "@/core/services/api/endpoints/manager/CompanyEndpoint";
import TransactionEndpoint from "@/core/services/api/endpoints/manager/TransactionEndpoint";
import KYCEndpoint from "@/core/services/api/endpoints/manager/KYCEndpoint";
import ReportEndpoint from "@/core/services/api/endpoints/manager/ReportEndpoint";
import ImportEndpoint from "@/core/services/api/endpoints/manager/ImportEndpoint";
import TicketEndpoint from "@/core/services/api/endpoints/manager/TicketEndpoint";
import ExchangeEndpoint from "@/core/services/api/endpoints/manager/ExchangeEndpoint";
import AnnouncementEndpoint from "@/core/services/api/endpoints/manager/AnnouncementEndpoint";
import AffiliateCompanyEndpoint from "@/core/services/api/endpoints/manager/AffiliateCompanyEndpoint";
import CryptoEndpoint from "@/core/services/api/endpoints/manager/CryptoEndpoint";
import CompanyProductEndpoint from "@/core/services/api/endpoints/manager/CompanyProductEndpoint";
import PortalServiceEndpoint from "@/core/services/api/endpoints/manager/PortalServiceEndpoint";
import FlexpspEndpoint from "@/core/services/api/endpoints/manager/FlexpspEndpoint";
import WhiteLabelOwnerEndpoint from "@/core/services/api/endpoints/manager/WhiteLabelOwnerEndpoint";

class ManagerEndpoints {
  public bank_account = new BankAccountEndpoint();
  public notification = new NotificationEndpoint();
  public activity_log = new ActivityLogEndpoint();
  public company = new CompanyEndpoint();
  public transaction = new TransactionEndpoint();
  public kyc = new KYCEndpoint();
  public ticket = new TicketEndpoint();
  public crypto = new CryptoEndpoint();
  public report = new ReportEndpoint();
  public import = new ImportEndpoint();
  public exchange = new ExchangeEndpoint();
  public announcement = new AnnouncementEndpoint();
  public affiliates = new AffiliateCompanyEndpoint();
  public white_label_owner = new WhiteLabelOwnerEndpoint();
  public product = new CompanyProductEndpoint();
  public portal_service = new PortalServiceEndpoint();
  public flexpsp = new FlexpspEndpoint();
}

export default ManagerEndpoints;
